import { EntityPresenterMode, isStaticMode } from './presenterEntityMode';

import type { Maybe } from '@nova/core';
import type { YardAssetVisitDetails } from './yardAssetVisitPresenterShared';

export function nestedAssetVisitPresenterDataProps(
  mode: EntityPresenterMode,
  data: { assetVisit?: Maybe<YardAssetVisitDetails> }
) {
  if (isStaticMode(mode)) {
    return {
      staticAssetVisitData: data.assetVisit ?? null
    };
  }

  return {
    placeholderAssetVisitData: data.assetVisit ?? null
  };
}
